import { useAppSelector } from '../../../App/services/hooks';
import { mapTestPrepDefaultTabSelectorStatus } from '../mappers/TestPrepStateMappers';

export const useTestPrepDefaultTabSelector = (): boolean => {
  const testPrepDefaultTabSelectorStatus = useAppSelector(
    mapTestPrepDefaultTabSelectorStatus,
  );
  return testPrepDefaultTabSelectorStatus;
};
